import { HttpRequest } from "../utils";

const httpRequest = new HttpRequest();

export const get = async (data: { date: any; limitDate: any; pieDate: any }) => {
  return httpRequest.get(`/api/program/dashboard`, data);
};
